import React, { useEffect } from "react";
import { Images } from "../../../../assets/images";
import { eventBookingStatus } from "../../../../constants";

const NotifyAdminEditEvent = (props) => {
  const { handleDraftEditEvent, selectedFormEvent } = props;

  useEffect(() => {
    // Only trigger if not already notified
    if (selectedFormEvent?.status !== eventBookingStatus.NOTIFY_ADMIN) {
      handleDraftEditEvent();
    }
  }, [selectedFormEvent?.id]);

  return (
    <div className="col-12 mt-4">
      <div className="draft-event-shutterB text-center py-5 px-3">
        <p className="label-content clr-black">
          Unfortunately we could not match your event details to a shutterb.
        </p>

        <p className="text-content mt-1">Admin will reassign the ShutterBz.</p>

        {selectedFormEvent?.status === eventBookingStatus.NOTIFY_ADMIN && (
          <div className=" d-flex justify-content-center align-items-end">
            <img
              className="draft-event-selected-img"
              src={Images.TickMark}
              alt=""
            />
            <p className="label-content mt-4 teal-color mb-0 ml-1">
              Event is selected as notify to admin
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotifyAdminEditEvent;
